import { pipe, toUpper, replace } from 'ramda';
import moment from 'moment';

type StringFormatter = (a: string) => string;
// test comment to check publish in pipeline
const mutateStringToMomentFormat: StringFormatter = pipe(toUpper, replace(/O/g, 'o'))

export const parseYear = (yearFormat: string) => moment().format(mutateStringToMomentFormat(yearFormat));
